import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import { useModal } from "@/hooks";
import styles from "@/styles/Modal.module.scss";
import Link from "next/link";
export default function CreditCardTermModal() {
  const { hideModal } = useModal();
  return (
    <div className={styles.cvv}>
      <h4 className={styles.title}> 利用上の注意</h4>
      <div className={styles.description}>
        クレジットカード番号などの情報の盗用による不正利用を防ぎ、安全にクレジットカードをご利用いただくため、国際ブランドの推奨する本人認証サービス「EMV3Dセキュア」を用いています。
        <br />
        当社は、EMV3Dセキュアを利用するために、クレジットカード発行会社に対しお客様に関する情報などを送信する必要がございます。
        <br />
        以下の「個人情報の第三者提供について」をご確認いただき、同意のうえクレジットカード情報をご入力ください。
        <br />
        <br />
        個人情報の第三者提供について
        当社は、お客様から収集した以下の個人情報等について、クレジットカード発行会社が行う不正利用検知・防止のために、お客様が利用されているクレジットカード発行会社に対して暗号化して電子的送信を行い提供させていただきます。
        <br />
        提供する個人情報等：カード名義、メールアドレス、IPアドレス、デバイス情報、インターネット利用環境
        <br />
        <br />
        お客様が利用されているクレジットカード発行会社が外国にある場合、これらの個人情報等について、当該発行会社が所属する国に移転される場合があります。当社では、お客様から収集した情報からは、ご利用のクレジットカード発行会社及び当該会社が所在する国を特定することができないため、あらかじめお客様に対して情報提供が必要となる以下の事項についてご提供することはできません。
        <br />
        ・提供先が所在する外国の名称
        <br />
        ・当該国の個人情報保護制度に関する情報
        <br />
        ・発行会社の個人情報保護の措置
        <br />
        なお、個人情報保護委員会のホームページ（
        <Link href="https://www.ppc.go.jp/" target="_blank">
          https://www.ppc.go.jp/
        </Link>
        ）では、各国における個人情報保護制度に関する情報について掲載されています。
        <br />
        <br />
        当社サービスに関する個人情報の取扱いについては、スカパー！関連サービスプライバシーポリシーをご確認ください。
        <br />
        <Link href="https://www.skyperfectv.co.jp/policy/" target="_blank">
          https://www.skyperfectv.co.jp/policy/
        </Link>
      </div>
      <div className={`${styles.btnArea} ${styles.multiple} ${styles.button}`}>
        <ButtonMultiClick borderGray fontFixed large onClick={hideModal}>
          閉じる
        </ButtonMultiClick>
      </div>
    </div>
  );
}
